import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { FilterTypeItem } from "../components/shared/filter-type-autocomplete";

export enum ActionTypecategory {
  Asset = "Asset",
  Billing = "Billing",
  BillingManagement = "Billing Management",
  FeatureFlag = "Feature Flag",
  Identity = "Identity",
  Integrations = "Integrations",
  Inspection = "Inspection",
  LoneWorker = "Lone Worker",
  Marketplace = "Marketplace",
  Media = "Media",
  Organisation = "Organisation",
  Periscope = "Periscope",
  PublicLibrary = "Public Library",
  Search = "Search",
  Sensors = "Sensors",
  Template = "Template",
  Translations = "Translations",
  User = "User",
  Workflow = "Workflow",
  WorkflowManagement = "Workflow Management",
  Training = "Training",
  ContentLibrary = "Content Library",
  AI = "AI",
  Contractor = "Contractor",
}

export const AssetsActions: FilterTypeItem[] = [
  {
    DisplayName: "List assets belonging to an organisation",
    Category: ActionTypecategory.Asset,
    Value: ActionType.LIST_ASSETS,
  },
];

export const BillingActions: FilterTypeItem[] = [
  {
    DisplayName: "Update payment method",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_PAYMENT_METHOD,
  },
  {
    DisplayName: "Deprecated: Update tax exempt",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_TAX_EXEMPT,
  },
  {
    DisplayName: "Update trial date",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_TRIAL_DATE,
  },
  {
    DisplayName: "Cancel subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CANCEL_SUBSCRIPTION,
  },
  {
    DisplayName: "Update seat movement restriction",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SEAT_MOVEMENTS_RESTRICTION,
  },
  {
    DisplayName: "List organisation contracts",
    Category: ActionTypecategory.Billing,
    Value: ActionType.LIST_ORG_CONTRACTS,
  },
  {
    DisplayName: "Get subscription seat usage",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_SUBSCRIPTION_SEAT_USAGE,
  },
  {
    DisplayName: "Get billing details",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_BILLING_DETAILS,
  },
  {
    DisplayName: "Create enterprise metadata",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CREATE_ENTERPRISE_METADATA,
  },
  {
    DisplayName: "Update subscription component price",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SUBSCRIPTION_COMPONENT_PRICE,
  },
  {
    DisplayName: "Get subscription components",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_SUBSCRIPTION_COMPONENTS,
  },
  {
    DisplayName: "Create billing details",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CREATE_BILLING_DETAILS,
  },
  {
    DisplayName: "Get plan type metadata from subscription ID",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_PLAN_TYPE_METADATA,
  },
  {
    DisplayName: "Validate a discount coupon",
    Category: ActionTypecategory.Billing,
    Value: ActionType.VALIDATE_COUPON,
  },
  {
    DisplayName: "Apply a discount coupon to a subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.APPLY_COUPON,
  },
  {
    DisplayName: "Remove a discount coupon from a subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.REMOVE_SUBSCRIPTION_COUPON,
  },
  {
    DisplayName: "Update subscription component quantity",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SUBSCRIPTION_COMPONENT_QUANTITY,
  },
  {
    // Should check which one is deprecated, there's two with the same name
    DisplayName: "Update subscription component price point",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SUBSCRIPTION_COMPONENT_PRICE_POINT,
  },
  {
    DisplayName: "Get contract plans by organization",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_CONTRACT_PLANS_BY_ORG,
  },
  {
    DisplayName: "Deprecated: Process true-up billing",
    Category: ActionTypecategory.Billing,
    Value: ActionType.PROCESS_TRUEUP,
  },
  {
    DisplayName: "Deprecated: Get organisation true-up details",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_ORG_TRUEUP_DETAILS,
  },
  {
    DisplayName: "Reactivate subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.REACTIVATE_SUBSCRIPTION,
  },
  {
    DisplayName: "Deprecated: Enable true-up experience",
    Category: ActionTypecategory.Billing,
    Value: ActionType.ENABLE_TRUE_UP_EXPERIENCE,
  },
  {
    DisplayName: "Update product plan",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_PRODUCT_PLAN,
  },
  {
    DisplayName: "Downgrade subscription to free",
    Category: ActionTypecategory.Billing,
    Value: ActionType.DOWNGRADE_SUBSCRIPTION_TO_FREE,
  },
  {
    DisplayName: "Update billing details",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_BILLING_DETAILS,
  },
  {
    DisplayName: "Update contract term",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_CONTRACT_TERM,
  },
  {
    DisplayName: "Update billing frequency",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_BILLING_FREQUENCY,
  },
  {
    DisplayName: "Update subscription currency",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SUBSCRIPTION_CURRENCY,
  },
  {
    DisplayName: "Update cancel at end of period",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_CANCEL_AT_END_OF_PERIOD,
  },
  {
    DisplayName: "Deprecated: Sync organization seats",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SYNC_ORG_SEATS,
  },
  {
    DisplayName: "Get organisation payment methods",
    Category: ActionTypecategory.Billing,
    Value: ActionType.GET_PAYMENT_METHODS,
  },
  {
    DisplayName: "Removes an organisation payment method",
    Category: ActionTypecategory.Billing,
    Value: ActionType.DELETE_PAYMENT_METHODS,
  },
  {
    DisplayName: "Deprecated: Update Contract",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_CONTRACT,
  },
  {
    DisplayName: "Update unrestricted trial date",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_UNRESTRICTED_TRIAL_DATE,
  },
  {
    DisplayName:
      "Syncs an organisation's payment method from provider to internal",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SYNC_PAYMENT_METHOD,
  },
  {
    DisplayName: "Deprecated: Remove payment profile",
    Category: ActionTypecategory.Billing,
    Value: ActionType.REMOVE_PAYMENT_PROFILE,
  },
  {
    DisplayName: "Deprecated: Billing - Change contracted dates",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CHANGE_CONTRACTED_DATES,
  },
  {
    DisplayName: "Deprecated: Billing - Update subscription state",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_SUBSCRIPTION_STATE,
  },
  {
    DisplayName: "Deprecated: Update billing currency",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_BILLING_CURRENCY,
  },
  {
    DisplayName: "Deprecated: Update product type",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_PRODUCT_TYPE,
  },
  {
    DisplayName: "Deprecated: Update billing date",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_BILLING_DATE,
  },
  {
    DisplayName:
      "Deprecated: Billing - Upgrade without credit card (use upgrade to premium instead)",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPGRADE_SUB_WITHOUT_CREDIT_CARD,
  },
  {
    DisplayName: "Upgrade to premium plan",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPGRADE_SUBSCRIPTION_TO_PREMIUM,
  },
  {
    DisplayName: "Billing - Sync Contract Data",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SYNC_CONTRACT_DATA,
  },
  {
    DisplayName: "Set Contract Enterprise State",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SET_CONTRACT_ENTERPRISE_STATE,
  },
  {
    DisplayName: "Set Contract Master Service Agreement State",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SET_CONTRACT_MSA_STATE,
  },
  {
    DisplayName: "Retry Payment Collection",
    Category: ActionTypecategory.Billing,
    Value: ActionType.RETRY_PAYMENT_COLLECTION,
  },
  {
    DisplayName: "Convert to Chargify trial subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CONVERT_TRIAL_SUBSCRIPTION,
  },
  {
    DisplayName: "Update Tax Exemption",
    Category: ActionTypecategory.Billing,
    Value: ActionType.UPDATE_TAX_EXEMPTION,
  },
  {
    DisplayName: "Sync with Zuora",
    Category: ActionTypecategory.Billing,
    Value: ActionType.SYNC_WITH_ZUORA,
  },
  {
    DisplayName: "Reconcile subscription seats",
    Category: ActionTypecategory.Billing,
    Value: ActionType.RECONCILE_SUBSCRIPTION,
  },
  {
    DisplayName: "Create trial subscription",
    Category: ActionTypecategory.Billing,
    Value: ActionType.CREATE_TRIAL_SUBSCRIPTION,
  },
];

export const BillingManagementActions: FilterTypeItem[] = [
  {
    DisplayName: "Get components",
    Category: ActionTypecategory.BillingManagement,
    Value: ActionType.GET_BILLING_COMPONENTS,
  },
  {
    DisplayName: "Get components with a default price",
    Category: ActionTypecategory.BillingManagement,
    Value: ActionType.GET_COMPONENTS_WITH_DEFAULT_PRICE,
  },
];

export const FeatureFlagActions: FilterTypeItem[] = [
  {
    DisplayName: "List segments",
    Category: ActionTypecategory.FeatureFlag,
    Value: ActionType.LIST_FEATURE_FLAG_SEGMENTS,
  },
  {
    DisplayName: "Get segment members",
    Category: ActionTypecategory.FeatureFlag,
    Value: ActionType.GET_FEATURE_FLAG_SEGMENT_MEMBERS,
  },
  {
    DisplayName: "Add segment members",
    Category: ActionTypecategory.FeatureFlag,
    Value: ActionType.ADD_FEATURE_FLAG_SEGMENT_MEMBERS,
  },
  {
    DisplayName: "Remove segment members",
    Category: ActionTypecategory.FeatureFlag,
    Value: ActionType.REMOVE_FEATURE_FLAG_SEGMENT_MEMBERS,
  },
  {
    DisplayName: "Evaluate all feature flags for a user or organisation",
    Category: ActionTypecategory.FeatureFlag,
    Value: ActionType.EVAL_ALL_FLAGS,
  },
];

export const IdentityActions: FilterTypeItem[] = [
  {
    DisplayName: "Get global identity organization",
    Category: ActionTypecategory.Identity,
    Value: ActionType.GET_ORGANIZATION_IDENTITY,
  },
  {
    DisplayName: "Get global identity user",
    Category: ActionTypecategory.Identity,
    Value: ActionType.GET_USER_IDENTITY,
  },
  {
    DisplayName: "Get users by identity ID",
    Category: ActionTypecategory.Identity,
    Value: ActionType.GET_USERS_BY_IDENTITY_ID,
  },
  {
    DisplayName: "Get identity by identity ID",
    Category: ActionTypecategory.Identity,
    Value: ActionType.GET_IDENTITY_BY_IDENTITY_ID,
  },
  {
    DisplayName: "Get an identity's org connections",
    Category: ActionTypecategory.Identity,
    Value: ActionType.GET_IDENTITY_LOGIN_INFO,
  },
  {
    DisplayName: "Update the preferred organisation of an identity",
    Category: ActionTypecategory.Identity,
    Value: ActionType.UPDATE_PREFERRED_ORG,
  },
  {
    DisplayName: "Update identity email",
    Category: ActionTypecategory.Identity,
    Value: ActionType.UPDATE_EMAIL,
  },
  {
    DisplayName: "Update identity username",
    Category: ActionTypecategory.Identity,
    Value: ActionType.UPDATE_USERNAME,
  },
  {
    DisplayName: "Update identity password",
    Category: ActionTypecategory.Identity,
    Value: ActionType.UPDATE_PASSWORD,
  },
];

export const IntegrationsActions: FilterTypeItem[] = [
  {
    DisplayName: "List integrations",
    Category: ActionTypecategory.Integrations,
    Value: ActionType.LIST_INSTALLATIONS,
  },
  {
    DisplayName: "List webhooks",
    Category: ActionTypecategory.Integrations,
    Value: ActionType.ADMIN_LIST_WEBHOOKS,
  },
  {
    DisplayName: "Migrate manifest in Workato customer accounts",
    Category: ActionTypecategory.Integrations,
    Value: ActionType.INTEGRATIONS_MIGRATE_MANIFEST,
  },
  {
    DisplayName: "Update webhook",
    Category: ActionTypecategory.Integrations,
    Value: ActionType.ADMIN_UPDATE_WEBHOOK,
  },
  {
    DisplayName: "Delete integrations",
    Category: ActionTypecategory.Integrations,
    Value: ActionType.DELETE_INSTALLATION,
  },
];

export const InspectionActions: FilterTypeItem[] = [
  {
    DisplayName: "Remove inspection report cache",
    Category: ActionTypecategory.Inspection,
    Value: ActionType.REMOVE_INSPECTION_REPORT_CACHE,
  },
];

export const MarketplaceActions: FilterTypeItem[] = [
  {
    DisplayName: "Get marketplace product attribute generation job result",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.GET_MARKETPLACE_PRODUCT_ATTR_JOB_RESULT,
  },
  {
    DisplayName: "List marketplace product attribute generation jobs",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.LIST_MARKETPLACE_PRODUCT_ATTR_GEN_JOBS,
  },
  {
    DisplayName: "List marketplace extract attributes",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.LIST_MARKETPLACE_EXTRACT_ATTRIBUTES,
  },
  {
    DisplayName: "List marketplace extract attribute groups",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.LIST_MARKETPLACE_EXTRACT_ATTRIBUTE_GROUPS,
  },
  {
    DisplayName: "List marketplace generate attributes",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.LIST_MARKETPLACE_GENERATE_ATTRIBUTES,
  },
  {
    DisplayName: "Add marketplace product attribute generation job",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.ADD_MARKETPLACE_PRODUCT_ATTR_GEN_JOB,
  },
  {
    DisplayName: "Add marketplace extract attribute",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.ADD_MARKETPLACE_EXTRACT_ATTRIBUTE,
  },
  {
    DisplayName: "Add marketplace generate attribute",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.ADD_MARKETPLACE_GENERATE_ATTRIBUTE,
  },
  {
    DisplayName: "Add marketplace extract attribute group",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.ADD_MARKETPLACE_EXTRACT_ATTRIBUTE_GROUP,
  },
  {
    DisplayName: "Delete marketplace extract attribute group",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.DELETE_MARKETPLACE_EXTRACT_ATTRIBUTE_GROUP,
  },
  {
    DisplayName: "Delete marketplace extract attribute",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.DELETE_MARKETPLACE_EXTRACT_ATTRIBUTE,
  },
  {
    DisplayName: "Delete marketplace generate attribute",
    Category: ActionTypecategory.Marketplace,
    Value: ActionType.DELETE_MARKETPLACE_GENERATE_ATTRIBUTE,
  },
];

export const MediaActions: FilterTypeItem[] = [
  {
    DisplayName: "Get metadata for media",
    Category: ActionTypecategory.Media,
    Value: ActionType.GET_MEDIA_METADATA,
  },
];

export const OrganisationActions: FilterTypeItem[] = [
  {
    DisplayName: "List organisation user fields",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_USER_ATTRIBUTE_FIELDS,
  },
  {
    DisplayName: "List organisation activity",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_ORGANISATION_ACTIVITY,
  },
  {
    DisplayName: "Deprecated: List organisation groups",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_ORGANISATION_GROUPS,
  },
  {
    DisplayName: "Deprecated: List pending invitations",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_PENDING_INVITATIONS,
  },
  {
    DisplayName: "List hardware sensors",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_HARDWARE_SENSORS_FOR_ORG,
  },
  {
    DisplayName: "List gateways",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_GATEWAYS_FOR_ORG,
  },
  {
    DisplayName: "Get organization with subscription",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_WITH_SUBSCRIPTION,
  },
  {
    DisplayName: "Get user list",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_USER_LIST,
  },
  {
    DisplayName: "Restore sites",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.RESTORE_SITES,
  },
  {
    DisplayName: "Get map organisation data status",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_MAP_ORGANISATION_DATA_STATUS,
  },
  {
    DisplayName: "Check feature flag from organisation ID",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.CHECK_FEATURE_FLAG_FROM_ORG_ID,
  },
  {
    DisplayName: "Update internal flags",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UPDATE_ORG_FLAGS,
  },
  {
    DisplayName: "Migrate to another data centre",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.MIGRATE_ORGANISATION,
  },
  {
    DisplayName: "Deprecated: Download sensor alerts",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.DOWNLOAD_SENSOR_ALERTS,
  },
  {
    DisplayName: "Download sensor alert history",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.DOWNLOAD_SENSOR_ALERT_HISTORY,
  },
  {
    DisplayName: "Delete organisation",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.DELETE_ORGANISATION,
  },
  {
    DisplayName: "Remove user from organisation",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.REMOVE_USER_FROM_ORG,
  },
  {
    DisplayName: "Deprecated: Revoke pending invite",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.REVOKE_PENDING_INVITE,
  },
  {
    DisplayName: "Map organisation data",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.MAP_ORGANISATION_DATA,
  },
  {
    DisplayName: "Bulk update users' seat type",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.BULK_UPDATE_USERS_SEAT_TYPE,
  },
  {
    DisplayName: "Bulk update users' email addresses",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_CHANGE_EMAIL_ADDRESS,
  },
  {
    DisplayName: "Promote user to org admin",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.PROMOTE_USER_TO_ORG_ADMIN,
  },
  {
    DisplayName: "Deprecated: Suspend and block users from signing in",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.SUSPEND_ORG,
  },
  {
    DisplayName: "Suspend organization and revoke all user tokens",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.SUSPEND_ORGANIZATION,
  },
  {
    DisplayName: "Unsuspend organization",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UNSUSPEND_ORGANIZATION,
  },
  {
    DisplayName: "Get bulk organization folders (sites)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.BULK_DOWNLOAD_FOLDERS,
  },
  {
    DisplayName: "Get organizations by org IDs",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORGANIZATIONS_BY_ORG_IDS,
  },
  {
    DisplayName: "Transfer multi-org user with their documents",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.TRANSFER_MULTI_ORG_USER,
  },
  {
    DisplayName: "Clones into a new organisation",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.CLONE_ORGANISATION,
  },
  {
    DisplayName: "Update org inspection quota",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UPDATE_ORG_INSPECTION_QUOTA,
  },
  {
    DisplayName: "Get org inspection quota",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_INSPECTION_QUOTA,
  },
  {
    DisplayName: "Get organisation details",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_DETAILS,
  },
  {
    DisplayName: "Get subscription data",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_SUBSCRIPTION,
  },
  {
    DisplayName: "Get Tesorio link",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_TESORIO_LINK,
  },
  {
    DisplayName: "Get SSO configuration (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_SSO_CONFIGURATION_ADMIN,
  },
  {
    DisplayName: "Delete SSO configuration (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.DELETE_SSO_CONFIGURATION_ADMIN,
  },
  {
    DisplayName: "Update SSO configuration (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UPDATE_SSO_CONFIGURATION_ADMIN,
  },
  {
    DisplayName: "Copy SSO configuration (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.COPY_SSO_CONFIGURATION_ADMIN,
  },
  {
    DisplayName: "Create SSO ticket (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.CREATE_SSO_TICKET_ADMIN,
  },
  {
    DisplayName: "Recreate SSO ticket (admin)",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.RECREATE_SSO_TICKET_ADMIN,
  },
  {
    DisplayName: "Deprecated: Enable training experience",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.ENABLE_ORGANISATION_TRAINING_EXPERIENCE,
  },
  {
    DisplayName: "List custom label replacements",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.LIST_WHITE_LABEL_REPLACEMENTS,
  },
  {
    DisplayName: "Create custom label replacement",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.CREATE_WHITE_LABEL_REPLACEMENT,
  },
  {
    DisplayName: "Update custom label replacement",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UPDATE_WHITE_LABEL_REPLACEMENT,
  },
  {
    DisplayName: "Delete custom label replacement",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.DELETE_WHITE_LABEL_REPLACEMENT,
  },
  {
    DisplayName: "Get Organization Groups",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORGANIZATION_GROUPS,
  },
  {
    DisplayName: "Get restrictions for organisation",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_RESTRICTIONS,
  },
  {
    DisplayName: "Create Demo Data in Organization",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.BULK_CREATE_DEMO_ORG_DATA,
  },
  {
    DisplayName: "Set Exclude Org from Analytics",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.SET_EXCLUDE_ORG_FROM_ANALYTICS,
  },
  {
    DisplayName: "Get org default template access",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_DEFAULT_TEMPLATE_ACCESS,
  },
  {
    DisplayName: "Set org default template access",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.UPDATE_ORG_DEFAULT_TEMPLATE_ACCESS,
  },
  {
    DisplayName: "Create organisation",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.CREATE_ORGANISATION,
  },
  {
    DisplayName: "Get org notification preferences",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.GET_ORG_NOTIFICATION_PREF,
  },
  {
    DisplayName: "List create or update user jobs",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.ADMIN_LIST_CREATE_OR_UPDATE_USERS_JOBS,
  },
  {
    DisplayName: "Get create or update user job details",
    Category: ActionTypecategory.Organisation,
    Value: ActionType.ADMIN_GET_CREATE_OR_UPDATE_USERS_JOB,
  },
];

export const PeriscopeActions: FilterTypeItem[] = [
  {
    DisplayName: "List user allowed actions",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_USER_ALLOWED_ACTIONS,
  },
  {
    DisplayName: "List all actions",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_ALL_ACTIONS,
  },
  {
    DisplayName: "List actions by group",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_ACTIONS_BY_GROUP,
  },
  {
    DisplayName: "List Sudo history",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_SUDO_HISTORY,
  },
  {
    DisplayName: "List audit logs",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_AUDIT_LOGS,
  },
  {
    DisplayName: "List groups",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_GROUPS,
  },
  {
    DisplayName: "List Okta Permission Groups by Action",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_GROUPS_BY_ACTION,
  },
  {
    DisplayName: "List Permissions",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_PERMISSIONS,
  },
  {
    DisplayName: "Create group",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.CREATE_GROUP,
  },
  {
    DisplayName: "Add permission",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.ADD_PERMISSIONS,
  },
  {
    DisplayName: "Add action",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.ADD_ACTION,
  },
  {
    DisplayName: "Remove group",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.REMOVE_GROUP,
  },
  {
    DisplayName: "Remove permission",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.REMOVE_PERMISSIONS,
  },
  {
    DisplayName: "Remove action",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.REMOVE_ACTION,
  },
  {
    DisplayName: "Generate Sudo credentials",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.GENERATE_CREDENTIALS,
  },
  {
    DisplayName: "Update Super Admin flag",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.UPDATE_USER_ADMIN_FLAG,
  },
  {
    DisplayName: "List User Okta Groups",
    Category: ActionTypecategory.Periscope,
    Value: ActionType.LIST_USER_OKTA_GROUPS,
  },
];

export const PublicLibraryActions: FilterTypeItem[] = [
  {
    DisplayName: "Delete template",
    Category: ActionTypecategory.PublicLibrary,
    Value: ActionType.DELETE_TEMPLATE,
  },
  {
    DisplayName: "Deprecated: Update public library template rating",
    Category: ActionTypecategory.PublicLibrary,
    Value: ActionType.MODIFY_PUBLIC_LIBRARY_TEMPLATE_RATING,
  },
  {
    DisplayName: "Deprecated: Update public library template",
    Category: ActionTypecategory.PublicLibrary,
    Value: ActionType.UPDATE_PUBLIC_LIBRARY_TEMPLATE,
  },
];

export const ContentLibraryActions: FilterTypeItem[] = [
  {
    DisplayName: "Get product types",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.GET_CONTENT_LIBRARY_PRODUCT_TYPES,
  },
  {
    DisplayName: "Unpublish product",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.UNPUBLISH_PRODUCT,
  },
  {
    DisplayName: "Publish product",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.PUBLISH_PRODUCT,
  },
  {
    DisplayName: "Get content library product preview",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.GET_PRODUCT_PREVIEW_PROXY,
  },
  {
    DisplayName:
      "Downloads the data file template where publisher can use for importing content",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.DOWNLOAD_FILE_TEMPLATE,
  },
  {
    DisplayName: "Bulk imports of content library's product",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.BULK_IMPORT_CONTENTS,
  },
  {
    DisplayName: "Get publisher",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.GET_PUBLISHER,
  },
  {
    DisplayName: "Create publisher",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.CREATE_PUBLISHER,
  },
  {
    DisplayName: "Update publisher",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.UPDATE_PUBLISHER,
  },
  {
    DisplayName: "Delete product",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.DELETE_PRODUCT,
  },
  {
    DisplayName: "Export products",
    Category: ActionTypecategory.ContentLibrary,
    Value: ActionType.EXPORT_PRODUCTS,
  },
];

export const SearchActions: FilterTypeItem[] = [
  {
    DisplayName: "Search Users",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_USERS,
  },
  {
    DisplayName: "Search Roles",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_ROLES,
  },
  {
    DisplayName: "Search Orgs",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_ORGS,
  },
  {
    DisplayName: "Deprecated: Search Subscription by credit card",
    Category: ActionTypecategory.Search,
    Value: ActionType.LIST_SUBS_BY_CREDIT_CARD,
  },
  {
    DisplayName: "Search raw json document",
    Category: ActionTypecategory.Search,
    Value: ActionType.GET_DOCUMENT_RAW,
  },
  {
    DisplayName: "Search public library templates",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_TEMPLATES,
  },
  {
    DisplayName: "search content library content",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_PRODUCTS,
  },
  {
    DisplayName: "Search organisations by sensors ID",
    Category: ActionTypecategory.Search,
    Value: ActionType.LIST_ORGANISATIONS_BY_SENSOR_ID,
  },
  {
    DisplayName: "Search organisations by gateway ID",
    Category: ActionTypecategory.Search,
    Value: ActionType.LIST_ORGANISATIONS_BY_GATEWAY_ID,
  },
  {
    DisplayName: "Search identities by identity ID",
    Category: ActionTypecategory.Search,
    Value: ActionType.SEARCH_IDENTITIES,
  },
];

export const SensorsActions: FilterTypeItem[] = [
  {
    DisplayName: "Get hardware sensor details",
    Category: ActionTypecategory.Sensors,
    Value: ActionType.GET_HARDWARE_SENSOR_DETAILS,
  },
];

export const TemplateActions: FilterTypeItem[] = [
  {
    DisplayName: "Restore template version from inspection",
    Category: ActionTypecategory.Template,
    Value: ActionType.RESTORE_TEMPLATE_VERSION,
  },
  {
    DisplayName: "Create new template from revision",
    Category: ActionTypecategory.Template,
    Value: ActionType.CREATE_TEMPLATE_FROM_REVISION,
  },
  {
    DisplayName: "Fix template site issue",
    Category: ActionTypecategory.Template,
    Value: ActionType.SPOT_FIX_TEMPLATE_SITE_ISSUE,
  },
  {
    DisplayName: "Copy template to a user",
    Category: ActionTypecategory.Template,
    Value: ActionType.COPY_TEMPLATE,
  },
  {
    DisplayName: "Gets older versions based on template id and revision id",
    Category: ActionTypecategory.Template,
    Value: ActionType.GET_TEMPLATE_VERSION_RAW,
  },
  {
    DisplayName: "Get template access rules",
    Category: ActionTypecategory.Template,
    Value: ActionType.GET_TEMPLATE_ACCESS_RULES,
  },
  {
    DisplayName: "List organisation templates",
    Category: ActionTypecategory.Template,
    Value: ActionType.LIST_ORG_TEMPLATES,
  },
  {
    DisplayName: "List organisation GRS",
    Category: ActionTypecategory.Template,
    Value: ActionType.LIST_ORG_GRS,
  },
  {
    DisplayName: "List template versions",
    Category: ActionTypecategory.Template,
    Value: ActionType.LIST_TEMPLATE_VERSIONS,
  },
];

export const TrainingActions: FilterTypeItem[] = [
  {
    DisplayName: "Get organisation training app features",
    Category: ActionTypecategory.Training,
    Value: ActionType.GET_ORG_TRAINING_APP_FEATURES,
  },
  {
    DisplayName: "Update organisation training app features",
    Category: ActionTypecategory.Training,
    Value: ActionType.UPDATE_ORG_TRAINING_APP_FEATURES,
  },
  {
    DisplayName: "Update induction feature settings",
    Category: ActionTypecategory.Training,
    Value: ActionType.UPDATE_INDUCTIONS_FEATURE_SETTINGS,
  },
  {
    DisplayName: "Get induction feature settings",
    Category: ActionTypecategory.Training,
    Value: ActionType.GET_INDUCTIONS_FEATURE_SETTINGS,
  },
  {
    DisplayName: "Start SC Training data migration workflow",
    Category: ActionTypecategory.Training,
    Value: ActionType.START_TRAINING_DATA_MIGRATION,
  },
  {
    DisplayName: "Get organisation courses",
    Category: ActionTypecategory.Training,
    Value: ActionType.GET_ORG_COURSES,
  },
  {
    DisplayName: "Copy course",
    Category: ActionTypecategory.Training,
    Value: ActionType.COPY_COURSE,
  },
  {
    DisplayName: "Download translations upgrade spreadsheet",
    Category: ActionTypecategory.Training,
    Value: ActionType.DOWNLOAD_TRANSLATIONS_UPGRADE_SPREADSHEET,
  },
  {
    DisplayName: "Start translations upgrade",
    Category: ActionTypecategory.Training,
    Value: ActionType.TRIGGER_TRANSLATIONS_UPGRADE,
  },
  {
    DisplayName: "Start EdApp customer migration workflow",
    Category: ActionTypecategory.Training,
    Value: ActionType.START_EDAPP_CUSTOMER_MIGRATION,
  },
  {
    DisplayName: "Start reverse training migration workflow",
    Category: ActionTypecategory.Training,
    Value: ActionType.START_REVERSE_TRAINING_MIGRATION,
  },
  {
    DisplayName: "Compare SC and Training users",
    Category: ActionTypecategory.Training,
    Value: ActionType.SC_TRAINING_USERS_COMPARISON,
  },
  {
    DisplayName: "Compare SC and Training groups",
    Category: ActionTypecategory.Training,
    Value: ActionType.SC_TRAINING_GROUPS_COMPARISON,
  },
  {
    DisplayName: "Start EdApp courseware migration",
    Category: ActionTypecategory.Training,
    Value: ActionType.START_EDAPP_COURSEWARE_MIGRATION,
  },
];

export const LoneWorkerActions: FilterTypeItem[] = [
  {
    DisplayName: "Get organisation loneworker settings",
    Category: ActionTypecategory.LoneWorker,
    Value: ActionType.GET_LONEWORKER_ORG_SETTINGS,
  },
  {
    DisplayName: "Update organisation loneworker settings",
    Category: ActionTypecategory.LoneWorker,
    Value: ActionType.UPDATE_LONEWORKER_ORG_SETTINGS,
  },
  {
    DisplayName: "Get organisation loneworker escalation groups",
    Category: ActionTypecategory.LoneWorker,
    Value: ActionType.GET_LONEWORKER_ESCALATION_GROUPS,
  },
];

export const TranslationsActions: FilterTypeItem[] = [
  {
    DisplayName: "Get Crowdin project languages",
    Category: ActionTypecategory.Translations,
    Value: ActionType.GET_CROWDIN_PROJECT_LANGUAGES,
  },
  {
    DisplayName: "Get Crowdin project files",
    Category: ActionTypecategory.Translations,
    Value: ActionType.GET_CROWDIN_PROJECT_FILES,
  },
  {
    DisplayName: "Upload Crowdin translations to template",
    Category: ActionTypecategory.Translations,
    Value: ActionType.UPLOAD_CROWDIN_TRANSLATIONS_TO_TEMPLATE,
  },
  {
    DisplayName: "Upload template to Crowdin",
    Category: ActionTypecategory.Translations,
    Value: ActionType.UPLOAD_TEMPLATE_TO_CROWDIN,
  },
];

export const UserActions: FilterTypeItem[] = [
  {
    DisplayName: "Get user attributes",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_ATTRIBUTES,
  },
  {
    DisplayName: "Get user details",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER,
  },
  {
    DisplayName: "Get login status",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_LOGIN_STATUS,
  },
  {
    DisplayName: "Get Inspection Quota",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_INSPECTION_QUOTA,
  },
  {
    DisplayName: "Get user by email",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_BY_EMAIL,
  },
  {
    DisplayName: "Get mobile diagnostic files",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_DIAGNOSTIC_FILES,
  },
  {
    DisplayName: "Analyse mobile diagnostic file",
    Category: ActionTypecategory.User,
    Value: ActionType.ANALYSE_DIAGNOSTIC_FILE,
  },
  {
    DisplayName: "Get user notification settings",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_NOTIFICATION_SETTINGS,
  },
  {
    DisplayName: "Get user navigation settings",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_NAVIGATION_SETTINGS,
  },
  {
    DisplayName: "List users last seen",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USERS_LAST_SEEN,
  },
  {
    DisplayName: "List templates",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USER_TEMPLATES,
  },
  {
    DisplayName: "List inspections",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USER_INSPECTIONS,
  },
  {
    DisplayName: "List user organisations",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_ORGANISATIONS,
  },
  {
    DisplayName: "List devices",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USER_DEVICES,
  },
  {
    DisplayName: "Deprecated: List groups",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USER_GROUPS,
  },
  {
    DisplayName: "List users activity log events",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USERS_ACTIVITY_LOG_EVENTS,
  },
  {
    DisplayName: "Trigger password reset email",
    Category: ActionTypecategory.User,
    Value: ActionType.TRIGGER_PASSWORD_RESET_EMAIL,
  },
  {
    DisplayName: "Update lite seat inspection limit",
    Category: ActionTypecategory.User,
    Value: ActionType.UPDATE_USER_INSPECTION_QUOTA,
  },
  {
    DisplayName: "Unblock login",
    Category: ActionTypecategory.User,
    Value: ActionType.UNBLOCK_USER_LOGIN,
  },
  {
    DisplayName: "Generate user access token",
    Category: ActionTypecategory.User,
    Value: ActionType.GENERATE_ACCESS_TOKEN,
  },
  {
    DisplayName: "Deprecated: Auto Accept Invitation",
    Category: ActionTypecategory.User,
    Value: ActionType.AUTO_ACCEPT_INVITATION,
  },
  {
    DisplayName: "Confirm email",
    Category: ActionTypecategory.User,
    Value: ActionType.CONFIRM_USER,
  },
  {
    DisplayName: "Delete token",
    Category: ActionTypecategory.User,
    Value: ActionType.DELETE_USER_TOKEN,
  },
  {
    DisplayName: "Transfer templates to another user",
    Category: ActionTypecategory.User,
    Value: ActionType.TRANSFER_USER_TEMPLATES,
  },
  {
    DisplayName: "Transfer inspections to another user",
    Category: ActionTypecategory.User,
    Value: ActionType.TRANSFER_USER_INSPECTIONS,
  },
  {
    DisplayName: "Create free team and subscription",
    Category: ActionTypecategory.User,
    Value: ActionType.CREATE_FREE_ORG_AND_SUB,
  },
  {
    DisplayName:
      "Deprecated: Transfer with templates and inspections to another organisation",
    Category: ActionTypecategory.User,
    Value: ActionType.TRANSFER_USER_WITH_DOCUMENTS,
  },
  {
    DisplayName: "Update active status",
    Category: ActionTypecategory.User,
    Value: ActionType.UPDATE_USERS_ACTIVE_STATUS,
  },
  {
    DisplayName: "Enable multi-org by email",
    Category: ActionTypecategory.User,
    Value: ActionType.ENABLE_MULTI_ORG_BY_EMAIL,
  },
  {
    DisplayName: "User: Sync user data",
    Category: ActionTypecategory.User,
    Value: ActionType.SYNC_USER_DATA,
  },
  {
    DisplayName:
      "Deprecated: User - List feature flags (use evaluate all flags instead)",
    Category: ActionTypecategory.User,
    Value: ActionType.LIST_USER_FEATURE_FLAGS,
  },
  {
    DisplayName: "Deprecated: User - Update privileges",
    Category: ActionTypecategory.User,
    Value: ActionType.UPDATE_USER_PRIVILEGES,
  },
  {
    DisplayName: "Deprecated: User - Update email",
    Category: ActionTypecategory.User,
    Value: ActionType.UPDATE_USER_EMAIL,
  },
  {
    DisplayName: "Get groups for user",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_GROUPS,
  },
  {
    DisplayName: "Get restrictions for user",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_USER_RESTRICTIONS,
  },
  {
    DisplayName: "Get folders for user",
    Category: ActionTypecategory.User,
    Value: ActionType.GET_FOLDERS_BY_USERS,
  },
];

export const WorkflowActions: FilterTypeItem[] = [
  {
    DisplayName: "List retroshares for template in an organisation",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.LIST_RETROSHARE,
  },
  {
    DisplayName: "Start retroshare for template in an organisation",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.START_RETROSHARE,
  },
  {
    DisplayName: "Bulk update inspection/template context for a user",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_UPDATE_DOCUMENTS_CONTEXT,
  },
  {
    DisplayName: "Bulk update the inspection titles",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_UPDATE_INSPECTION_TITLE,
  },
  {
    DisplayName: "Bulk archive inspections and templates",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.ARCHIVE_ALEXANDRIA_DOCUMENTS,
  },
  {
    DisplayName: "Bulk restore archived inspections",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_RESTORE_ARCHIVED_INSPECTIONS,
  },
  {
    DisplayName: "Archive inspections and templates by owner",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.ARCHIVE_DOCUMENT_BY_OWNER,
  },
  {
    DisplayName: "Bulk restore deleted inspections",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_RESTORE_DELETED_INSPECTIONS,
  },
  {
    DisplayName: "Bulk copy template permission and auto share",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_COPY_TEMPLATE_PERMISSION_AND_AUTO_SHARE,
  },
  {
    DisplayName: "Execute workflow by name",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.EXECUTE_WORKFLOW_BY_NAME,
  },
  {
    DisplayName: "Bulk restore documents from s3",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_RESTORE_DOCUMENTS_FROM_S3,
  },
  {
    DisplayName: "Pause SalesForce sync for 1h",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.PAUSE_SALESFORCE_SYNC,
  },
  {
    DisplayName: "Bulk add users to groups",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_ADD_USERS_TO_GROUPS,
  },
  {
    DisplayName: "Bulk transfer users with their documents",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_TRANSFER_USERS,
  },
  {
    DisplayName: "Reset org templates access",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.RESET_ORG_TEMPLATES_ACCESS,
  },
  {
    DisplayName: "Provision support user",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.PROVISION_SUPPORT_USER,
  },
  {
    DisplayName: "Bulk remove org users from SendGrid bounce list",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.BULK_REMOVE_ORG_USERS_FROM_BOUNCE_LIST,
  },
  {
    DisplayName: "Provision SC Care account",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.PROVISION_SC_CARE_ORG,
  },
  {
    DisplayName: "List SC Care records",
    Category: ActionTypecategory.Workflow,
    Value: ActionType.LIST_SC_CARE_RECORDS,
  },
];

export const WorkflowManagementActions: FilterTypeItem[] = [
  {
    DisplayName: "Lists the workflows in temporal for support",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.LIST_SUPPORT_WORKFLOW_EXECUTIONS,
  },
  {
    DisplayName: "Get support workflow status",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.GET_SUPPORT_WORKFLOW_STATUS,
  },
  {
    DisplayName: "Terminate support workflow execution",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.TERMINATE_SUPPORT_WORKFLOW_EXECUTION,
  },
  {
    DisplayName: "Signal Temporal workflow",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.SIGNAL_WORKFLOW,
  },
  {
    DisplayName: "Query Temporal workflow",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.QUERY_WORKFLOW,
  },
  {
    DisplayName: "Get workflow status",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.GET_WORKFLOW_STATUS,
  },
  {
    DisplayName: "Reset workflow execution",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.RESET_WORKFLOW_EXECUTION,
  },
  {
    DisplayName: "Signal subscriptions workflow",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.SIGNAL_SUBSCRIPTIONS_WORKFLOW,
  },
  {
    DisplayName: "Lists the subscriptions workflows in temporal",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.LIST_SUBSCRIPTIONS_WORKFLOW_EXECUTIONS,
  },
  {
    DisplayName: "List workflow executions",
    Category: ActionTypecategory.WorkflowManagement,
    Value: ActionType.LIST_WORKFLOW_EXECUTIONS,
  },
];

export const AIActions: FilterTypeItem[] = [
  {
    DisplayName: "Get Documents Ask AI settings",
    Category: ActionTypecategory.AI,
    Value: ActionType.GET_DOCUMENTS_ASK_AI_SETTINGS,
  },
  {
    DisplayName: "Update Documents Ask AI settings",
    Category: ActionTypecategory.AI,
    Value: ActionType.UPDATE_DOCUMENTS_ASK_AI_SETTINGS,
  },
  {
    DisplayName: "List org users' AI credit usage",
    Category: ActionTypecategory.AI,
    Value: ActionType.LIST_ORG_USER_RESTRICTIONS,
  },
  {
    DisplayName: "Get org AI credit configuration",
    Category: ActionTypecategory.AI,
    Value: ActionType.GET_ORG_RESTRICTION_CONFIGURATION,
  },
];

export const ContractorActions: FilterTypeItem[] = [
  {
    DisplayName: "List contractor companies for an organisation",
    Category: ActionTypecategory.Contractor,
    Value: ActionType.LIST_CONTRACTOR_COMPANIES,
  },
  {
    DisplayName: "List contractor company summaries",
    Category: ActionTypecategory.Contractor,
    Value: ActionType.LIST_CONTRACTOR_COMPANY_SUMMARIES,
  },
];

// Helper function to add parentCategory to all items in an array
const addParentCategory = (
  items: FilterTypeItem[],
  category: string
): FilterTypeItem[] => {
  return items.map((item) => ({ ...item, parentCategory: category }));
};

// Create category items with children
const createCategoryItems = (): FilterTypeItem[] => {
  const categories: Array<{
    category: ActionTypecategory;
    actions: FilterTypeItem[];
  }> = [
    { category: ActionTypecategory.Asset, actions: AssetsActions },
    { category: ActionTypecategory.Billing, actions: BillingActions },
    {
      category: ActionTypecategory.BillingManagement,
      actions: BillingManagementActions,
    },
    { category: ActionTypecategory.FeatureFlag, actions: FeatureFlagActions },
    { category: ActionTypecategory.Identity, actions: IdentityActions },
    {
      category: ActionTypecategory.Integrations,
      actions: IntegrationsActions,
    },
    { category: ActionTypecategory.Inspection, actions: InspectionActions },
    { category: ActionTypecategory.Marketplace, actions: MarketplaceActions },
    { category: ActionTypecategory.Media, actions: MediaActions },
    { category: ActionTypecategory.Organisation, actions: OrganisationActions },
    { category: ActionTypecategory.Periscope, actions: PeriscopeActions },
    {
      category: ActionTypecategory.PublicLibrary,
      actions: PublicLibraryActions,
    },
    {
      category: ActionTypecategory.ContentLibrary,
      actions: ContentLibraryActions,
    },
    { category: ActionTypecategory.Search, actions: SearchActions },
    { category: ActionTypecategory.Sensors, actions: SensorsActions },
    { category: ActionTypecategory.Template, actions: TemplateActions },
    { category: ActionTypecategory.Training, actions: TrainingActions },
    {
      category: ActionTypecategory.Translations,
      actions: TranslationsActions,
    },
    { category: ActionTypecategory.User, actions: UserActions },
    { category: ActionTypecategory.Workflow, actions: WorkflowActions },
    {
      category: ActionTypecategory.WorkflowManagement,
      actions: WorkflowManagementActions,
    },
    { category: ActionTypecategory.LoneWorker, actions: LoneWorkerActions },
    { category: ActionTypecategory.AI, actions: AIActions },
    { category: ActionTypecategory.Contractor, actions: ContractorActions },
  ];

  const result: FilterTypeItem[] = [];

  categories.forEach(({ category, actions }) => {
    // Add parent category to all child actions
    const childrenWithParent = addParentCategory(actions, category);

    // Create category node
    const categoryNode: FilterTypeItem = {
      DisplayName: category,
      Category: category,
      Value: `category:${category}`,
      isCategory: true,
      children: childrenWithParent,
    };

    // Add category node to result
    result.push(categoryNode);

    // Add all child actions to result (with parentCategory set)
    result.push(...childrenWithParent);
  });

  return result;
};

export const ActionTypeItems: FilterTypeItem[] = createCategoryItems();

// Flat array of only action items (no categories) for default selection
export const ActionTypeItemsFlat: FilterTypeItem[] = ActionTypeItems.filter(
  (item) => !item.isCategory
);

export const actionTypeToString = (actionType: ActionType): string => {
  for (const item of ActionTypeItems) {
    if (item.Value === actionType) {
      return item.DisplayName;
    }
  }
  return "Action not specified";
};
